import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote3 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>AIR-RES 2025</h1>
              <h6>The 2025 International Conference on the</h6>
              <h6>AI Revolution: Research, Ethics, and Society</h6>
              <h6>April 14-16, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>Unlocking Potential: A Framework for Engaging Undergraduate Students in Research and Scholarly Dissemination</b> <br/><br />
            Prof. Arshia Khan, Ph.D., Professor and Director of Graduate Studies, Department of Computer Science, University of Minnesota Duluth, USA; <br/>
            Prof. Anne Hinderliter, Ph.D., Professor of Chemistry/Biochemistry, University of Minnesota Duluth, USA; <br/>
            Prof. Sherri Turner, Ph.D., Professor of Counselor Education, University of Minnesota, Minneapolis, USA <br />
            </div>
        
            <h6 className="par_header">Introduction:</h6>
            <div className="par">
            Undergraduate research is a transformative experience that enhances students' critical thinking, problem-solving abilities, and career readiness. However, fostering sustained engagement requires more than just offering research opportunities—it demands a structured framework that supports students through the entire research cycle, from exploration to dissemination. In this talk, we will present our undergraduate research framework, designed to guide students in conducting research, writing scholarly papers, and presenting at conferences and poster sessions. This model emphasizes inclusive mentorship, research-integrated curriculum, and targeted support to empower students—especially academically talented students from historically marginalized backgrounds—to see themselves as active contributors to their fields. By sharing our approach and best practices, this presentation aims to provide actionable strategies for institutions seeking to cultivate a research-supportive culture and expand opportunities for undergraduate students in academia.
            </div>

            <h6 className="par_header">Biography – Prof. Arshia Khan:</h6>
            <div className="par">
            A strong advocate for diversity in STEM, Dr. Khan chairs the Women in Computing committee at Swenson College of Science and Engineering, securing grants and leading initiatives to increase gender inclusivity in computer science. She has spearheaded major multi-institutional projects, including a $1.6 million grant for deploying robots in nursing homes.
            Dr. Khan holds leadership roles in organizations addressing healthcare disparities, including as Programs Chair of the ISTAART Diversity and Disparities PIA Executive Committee and Co-Chair of the Rural Health Disparities Special Interest Group. She also serves on the advisory board for the Arrowhead Area Agency on Aging and contributes to the Masonic Institute for the Developing Brain (MIDB).
            A prolific researcher and author, Dr. Khan has published extensively on healthcare technology, robotics, and AI-driven solutions for dementia care. Her work has been featured in leading scientific journals and major media outlets, including CNN, Forbes, NPR, PBS’s NOVA, and The New York Times.
            </div>

            <h6 className="par_header">Speakers</h6>
            <div className="par" style={{ textAlign: "center" }}>
            <b>Arshia Khan</b>, Professor, Director of Graduate Studies, Department of Computer Science <br/>
            Programs Chair of the ISTAART Diversity and Disparities PIA Executive Committee of the Alzheimer's Association International Society to Advance Alzheimer’s Research and Treatment (ISTAART) <br/>
            <a href="http://www.d.umn.edu/~akhan" target="_blank" rel="noopener noreferrer">http://www.d.umn.edu/~akhan</a> <br/>
            University of Minnesota Duluth, USA <br/><br />
            <div style={{textAlign: "center"}}>
                <img src="/static/AKhan.jpg" height="300px" alt="" style={{ margin: "0.5rem" }}/> <br />
            </div>
            <br/><br/>
<hr />
            <b>Anne Hinderliter, Ph.D.</b>, Professor of Chemistry/Biochemistry, University of Minnesota Duluth, USA <br/>
            <br />
            <div style={{textAlign: "center"}}>
                <img src="/static/Hinderliter.png" height="300px" alt="" style={{ margin: "0.5rem" }}/> <br />
            </div>
            <br/><br/>

            <hr />

            <b>Sherri Turner, Ph.D.</b>, Professor of Counselor Education, University of Minnesota, Minneapolis, USA <br/>
            <br />
            <div style={{textAlign: "center"}}>
                <img src="/static/STurner.png" height="300px" alt="" style={{ margin: "0.5rem" }}/>
            </div>
            </div>

            
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote3;